import { Button } from "@fc/devteam-components-library";
import { useTranslation } from "react-i18next";
import ModalComponet, { ModalFooter} from ".";

export default function ModalRestricted(props: {open: boolean, onClose: () => void, action: () => void}) {
    const { t } = useTranslation(['restricted']);

    const restrictSection = () => {
        props.action()
        props.onClose()
    }
    return (
        <ModalComponet open={props.open} onClose={restrictSection}>
            <>
            <p className="Title5">
                {t('title')}
            </p>
            <div className="HorizontalFlex__Gap items__center modal-restricted">
                {/* <i className="far fa-exclamation-circle" /> */}
                <p className="Body2">
                    {t('text')}
                </p>
            </div>
            <ModalFooter>
                <Button
                    buttontype='button'
                    buttontext={t('button')}
                    action={restrictSection}
                />
            </ModalFooter>
            </>
        </ModalComponet>
    )
};